import {COCKPIT_EVENTS_PAGE_TAB_PARAM_KEY} from '@hconnect/common/consts'
import {EventsTab} from '@hconnect/common/types'
import {Page} from '@widgets/shift-event-filters'
import {matchRoutes, useLocation} from 'react-router'

import {
  routeToEvents,
  routeToPerformance,
  routeToRecurringTasks,
  routeToSummary,
  routeToTasks
} from '../routes'

const pageRoutes = [
  {path: routeToEvents, page: Page.Events},
  {path: routeToTasks, page: Page.Tasks},
  {path: routeToSummary, page: Page.Summary},
  {path: routeToPerformance, page: Page.Performance},
  {path: routeToRecurringTasks, page: Page.RecurringTasks}
]

export function useResolvePageFromLocation(): Page | undefined {
  const {pathname, search} = useLocation()

  const match = matchRoutes(pageRoutes, pathname)
  if (!match) return
  const matchedRoute = pageRoutes.find(({path}) => path === match[0].route.path)
  if (!matchedRoute) return

  if (matchedRoute.page === Page.Events) {
    const params = new URLSearchParams(search)
    const tab = params.get(COCKPIT_EVENTS_PAGE_TAB_PARAM_KEY) as EventsTab | null

    if (tab === EventsTab.WorkOrders) return Page.WorkOrders
    if (tab === EventsTab.Notifications) return Page.Notifications
    return Page.Events
  }

  return matchedRoute.page
}
